<template>
	<div class="private-order-detail-image-mobile">
		<div v-if="!isProductLoading" class="main-picture-wrapper">
			<div v-if="showPrev" class="prev-button" @click="handleChangeSelectedImage(-1)">
				<i class="bi bi-chevron-left"></i>
			</div>

			<img
				:src="mainImage.url"
				alt="product-image"
				class="main-picture"
				@click="handleClickImage"
			/>

			<div v-if="mainImage.type === 'video'" class="video-play" @click="handleClickImage">
				<i class="bi bi-play-fill"></i>
			</div>

			<div class="image-counter" :class="{ 'fade-out': !showImageCounter }">
				{{ imageCounterVal }}
			</div>

			<div v-if="showNext" class="next-button" @click="handleChangeSelectedImage(1)">
				<i class="bi bi-chevron-right"></i>
			</div>
		</div>

		<div v-if="isProductLoading" class="main-picture-skeleton skeleton"></div>
	</div>
</template>

<script>
export default {
	components: {},
	props: {
		images: {
			type: Array,
			default: () => [],
		},
		activeIndex: {
			type: Number,
			default: 0,
		},
		isProductLoading: {
			type: Boolean,
			required: true,
		},
	},
	data() {
		return {
			showImageCounter: true,
			imageCounterTimoutId: null,
		};
	},
	computed: {
		mainImage() {
			// eslint-disable-next-line arrow-parens
			return this.images.find((item) => item.active === true);
		},
		showPrev() {
			return !this.isProductLoading && this.activeIndex !== 0 && this.images.length > 4;
		},
		showNext() {
			return (
				!this.isProductLoading
				&& this.activeIndex !== this.images.length - 1
				&& this.images.length > 4
			);
		},
		imageCounterVal() {
			return `${this.activeIndex + 1}/${this.images.length}`;
		},
	},
	watch: {
		showImageCounter: {
			handler(newValue) {
				if (newValue) {
					this.fadeImageCounter();
				}
			},
		},
	},
	methods: {
		handleChangeSelectedImage(increment) {
			this.showImageCounter = true;
			this.$emit('move-image', increment);
		},
		handleClickImage() {
			this.$emit('click-image', true);
		},
		fadeImageCounter() {
			if (this.imageCounterTimoutId) {
				clearTimeout(this.imageCounterTimoutId);
			}

			this.imageCounterTimoutId = setTimeout(() => {
				this.showImageCounter = false;
			}, 3000);
		},
	},
	mounted() {
		this.fadeImageCounter();
	},
};
</script>

<style scoped lang="scss">
.private-order-detail-image-mobile {
	width: 100%;
	height: fit-content;
	display: flex;
	align-items: center;
	gap: 8px;
	margin-top: 10px;
}

.main-picture-wrapper {
	width: 100%;
	aspect-ratio: 1;
	cursor: pointer;
	position: relative;
	display: flex;
	align-items: center;

	& > .image-counter {
		position: absolute;
		width: auto;
		height: auto;
		background-color: white;
		border: 1px solid #00000044;
		border-radius: 6px;
		z-index: 2;
		bottom: 8px;
		left: 8px;
		font-size: 14px;
		display: flex;
		justify-content: center;
		align-items: center;
		padding: 1px 5px;

		&.fade-out {
			animation: imageCounterFadeOut 1s forwards;

			@keyframes imageCounterFadeOut {
				from {
					opacity: 1;
				}
				to {
					opacity: 0;
				}
			}
		}
	}

	& > .video-play {
		position: absolute;
		z-index: 1;
		width: 60px;
		height: 60px;
		left: calc(50% - 30px);
		top: calc(50% - 30px);
		border-radius: 100%;
		background-color: #00000068;
		border: 1.5px solid #ffffffcd;
		color: #ffffffcd;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 28px;
		padding-top: 1px;
		padding-left: 3px;
	}

	& > .prev-button,
	.next-button {
		position: absolute;
		width: 36px;
		height: 56px;
		background-color: rgba(77, 77, 78, 0.506);
		display: flex;
		justify-content: center;
		align-items: center;
		color: #ffffffcc;
		cursor: pointer;
		z-index: 2;
		font-size: 18px;
	}

	& > .prev-button {
		border-radius: 0 4px 4px 0;
		left: 0;
	}

	& > .next-button {
		border-radius: 4px 0 0 4px;
		right: 0;
	}
}

img.main-picture {
	width: 100%;
	aspect-ratio: 1/1;
	object-fit: cover;
	border-radius: 8px;
	box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.075);
	border: 0.5px solid #d9dadd75;
}

.main-picture-skeleton {
	width: 100%;
	aspect-ratio: 1;
	border-radius: 8px;
}
</style>
